import React from "react"
import { getFenixShippingEstimate } from "@utils/api"
import { UNKNOWN_LOCATION } from "@redux/utils"
import _ from "lodash-es"

const findShippingDataForMethod = (data, method) =>
  _.find(data, ({ shippingMethodDesc }) => shippingMethodDesc === method)

const formatShippingData = (responseData) => {
  const shippingData = {}

  responseData.forEach((d) => {
    const variants = d.webId?.split(",")
    variants.forEach((v) => {
      if (shippingData[v]) {
        shippingData[v].push(d)
      } else {
        shippingData[v] = [d]
      }
    })
  })

  return shippingData
}

export default (zipCode, variants, shippingMethods) => {
  const [invalidShippingData, setInvalidShippingData] =
    React.useState<boolean>(false)
  const [shippingDataLoaded, setShippingDataLoaded] =
    React.useState<boolean>(false)
  const [shippingData, setShippingData] = React.useState({})
  const [zipCodeError, setZipCodeError] = React.useState<boolean>(false)
  const [zipCodeErrorMessage, setZipCodeErrorMessage] = React.useState<
    string | undefined
  >(undefined)

  const [expeditedShipping, expressShipping, standardShipping] = shippingMethods

  const getShippingDataForSku = React.useCallback(
    (sku) => {
      const variantShippingMethods = shippingData[sku]

      return (
        variantShippingMethods &&
        (findShippingDataForMethod(variantShippingMethods, expeditedShipping) ||
          findShippingDataForMethod(variantShippingMethods, expressShipping) ||
          findShippingDataForMethod(variantShippingMethods, standardShipping))
      )
    },
    [shippingData]
  )

  React.useEffect(() => {
    if (zipCode === UNKNOWN_LOCATION) {
      setInvalidShippingData(false)
      setShippingDataLoaded(true)
      setZipCodeError(true)
      setZipCodeErrorMessage(undefined)
    } else if (zipCode) {
      getFenixShippingEstimate(
        zipCode,
        variants.map(({ sku }) => ({ sku, quantity: 1 }))
      )
        .then((data) => {
          setShippingData(formatShippingData(data))
          setShippingDataLoaded(true)
          setInvalidShippingData(false)
          setZipCodeError(false)
        })
        .catch(({ response }) => {
          const [match] =
            (response &&
              response.data &&
              response.data.match("Invalid Buyer Zipcode")) ||
            []

          if (match) {
            setInvalidShippingData(false)
            setZipCodeErrorMessage("Invalid Buyer Zipcode")
          } else {
            setInvalidShippingData(true)
            setZipCodeErrorMessage(undefined)
          }

          setShippingDataLoaded(true)
          setZipCodeError(true)
        })
    }
  }, [zipCode, variants])

  return {
    invalidShippingData,
    shippingDataLoaded,
    shippingData,
    zipCodeError,
    zipCodeErrorMessage,
    getShippingDataForSku,
  }
}
